<script setup lang="ts">
import { cardActions } from "@/action/cardActions";
import { getAlmInfo } from "@/backend/read/BackendReader";
import { cardKey } from "@/components/StickyNote/injectKeys";
import ActionMenuDropdown from "@/components/menu/ActionMenu/ActionMenuDropdown.vue";
import { useServerSettingsStore } from "@/store/serverSettings";
import { injectStrict } from "@/utils/vue";

import DevLinksMenu from "./DevLinksMenu.vue";
import { useDevLinks } from "./useDevLinks";

const card = injectStrict(cardKey);

const enabled = useServerSettingsStore().showDevLinks && getAlmInfo().hasDevLinks && !!card.almId;

const { devLinks, loaded, load } = useDevLinks(card.almId);

if (enabled) {
  void load();
}
</script>

<template>
  <ActionMenuDropdown v-if="enabled" :action="cardActions.openDevLinks" width="lg">
    <DevLinksMenu :dev-links :loading="!loaded" />
  </ActionMenuDropdown>
</template>
